"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixpanelContext = void 0;
const mixpanelWindow = typeof window !== "undefined" ? window : {};
const mixpanelContext = () => {
    let user;
    const sessionReplayContext = (ctx) => {
        if (mixpanelWindow.mixpanel) {
            const segmentDeviceId = user.anonymousId();
            mixpanelWindow.mixpanel.register({
                $device_id: segmentDeviceId,
                distinct_id: segmentDeviceId,
            });
            const sessionReplayProperties = mixpanelWindow.mixpanel.get_session_recording_properties();
            if (sessionReplayProperties === null || sessionReplayProperties === void 0 ? void 0 : sessionReplayProperties.$mp_replay_id) {
                ctx.updateEvent("properties.$mp_replay_id", sessionReplayProperties.$mp_replay_id);
            }
        }
        return ctx;
    };
    const identify = (ctx) => {
        if (mixpanelWindow.mixpanel) {
            const userId = user.id();
            mixpanelWindow.mixpanel.identify(userId);
        }
        return ctx;
    };
    return {
        name: "Mixpanel Context",
        type: "before",
        version: "0.1.0",
        load: (_ctx, ajs) => __awaiter(void 0, void 0, void 0, function* () {
            user = ajs.user();
        }),
        isLoaded: () => user !== undefined,
        page: sessionReplayContext,
        track: sessionReplayContext,
        identify,
    };
};
exports.mixpanelContext = mixpanelContext;
